module.exports = __webpack_public_path__ + "static/img/home.f466064.png";


//////////////////
// WEBPACK FOOTER
// ./static/tutorial/home.png
// module id = Angr
// module chunks = 14